import ModalBody from "Components/Common/Modal/ModalBody"
import ModalContainer from "Components/Common/Modal/ModalContainer"
import ModalFooter from "Components/Common/Modal/ModalFooter"
import ModalHeader from "Components/Common/Modal/ModalHeader"
import FillButton from "Components/Common/components/Button/FillButton"
import OutlineButton from "Components/Common/components/Button/OutlineButton"
import Label from "Components/Common/components/Label"
import React, { MouseEventHandler } from "react"
import alertIcon from "assests/img/alert-icons.svg";


type MyProps = {
  isOpen: boolean,
  handleConfirm: MouseEventHandler<HTMLButtonElement>,
  onClose: Function
  loading: boolean
}

const ConfirmBulkDelete = ({
  isOpen,
  onClose,
  handleConfirm,
  loading
}: MyProps) => {
    return (
      <ModalContainer isOpen={isOpen} setOpen={onClose} width='500px'>
        <ModalHeader>
            <div className = "tw-my-2">
                <Label
                message={"Upload XLS - Bulk Delete"}
                fontSize={"0.875"}
                fontWeight="600"
                />
            </div>
        </ModalHeader>

        <ModalBody>
            <div className="tw-flex tw-flex-col tw-space-y-3 tw-my-2.5">
                <h5 className="tw-font-bold">
                    Bulk delete products
                </h5>
                <div className="tw-flex tw-space-x-3 tw-p-2.5 tw-rounded tw-border tw-border-alert tw-bg-alert">
                    <img src={alertIcon} alt="Alert icon" />
                    <p className='tw-text-xs'>
                        This action will permanently delete the product or remove its channel dependency if it is mapped to multiple channels.
                    </p>
                </div>
                <p>Would you like to proceed?</p>
            </div>
        </ModalBody>

        <ModalFooter>
          <div className="tw-space-x-3 min-w-full tw-justify-end tw-flex">
            <OutlineButton onClick={() => onClose()}>Cancel</OutlineButton>
            <FillButton disabled={loading} buttonStyle="danger" onClick={handleConfirm}>Delete</FillButton>
          </div>
        </ModalFooter>
      </ModalContainer>
    )
}

export default ConfirmBulkDelete